import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'

/**
 * Un signalement d'un contenu genere par l'IA (REDMINE-13560, AVN-24).
 *
 * L'application le cree, via consumer-api ; le back-office le lit et le traite.
 * Seuls `status` et `review_note` s'ecrivent : tout le reste est en lecture
 * seule, et l'intranet ignore de toute facon un autre champ dans le PATCH.
 *
 * `content` est une chaine JSON, la copie du contenu tel que l'utilisateur l'a
 * vu : `{reply, prompt}` pour une reponse du sommelier, `{proposal, enrichment}`
 * pour un scan.
 */
export default class AiContentReport extends Model {
  static entity = 'ai_content_reports'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      'kind': this.string(null).nullable(),
      'reason': this.string(null).nullable(),
      'comment': this.string(null).nullable(),
      'content': this.string(null).nullable(),
      'lang': this.string(null).nullable(),
      'conversation_id': this.attr(null),
      'api_data_conversation_id': this.attr(null),
      'api_data_message_id': this.attr(null),
      'ocr_scan_id': this.attr(null),
      'api_data_scan_id': this.attr(null),
      'status': this.string('open'),
      'review_note': this.string(null).nullable(),
      'reviewed_at': this.string(null).nullable(),
      'reviewed_by': this.string(null).nullable(),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = [
    'kind', 'reason', 'comment', 'content', 'lang',
    'conversation_id', 'api_data_conversation_id', 'api_data_message_id',
    'ocr_scan_id', 'api_data_scan_id', 'reviewed_at', 'reviewed_by'
  ]

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
